module.exports = __webpack_public_path__ + "img/ecosystem_01_fx.ee563d53.png";